import React, { FC, useContext } from "react"
import { Segment, Step } from "semantic-ui-react"

import { PreChekInStepEnum, StepperForm } from "../../common/types/checkin"
import GlobalContext from "../../contexts/GlobalContext"

import PreCheckInStep from "./PreCheckInStep"

type Props = {
  stepperForm: StepperForm
  isBookerPax: boolean
  handleStepGuard: any
  roomingList: any
}

const PreCheckInStepHeader: FC<Props> = ({
  stepperForm, isBookerPax, handleStepGuard, roomingList
}) => {
  const [globalContext] = useContext(GlobalContext) as any

  return (
    <Segment >
      <Step.Group 
        attached="top" 
        widths={!isBookerPax ? 3 : 2}
      >
        {(!isBookerPax && !roomingList) &&
          <PreCheckInStep 
            active={stepperForm.step === PreChekInStepEnum.Identity}
            /*onClick={() => handleStepGuard(PreChekInStepEnum.Identity)}*/
            icon='user'
            title={globalContext.translations.modalCheckInStepOneTitle}
            description={globalContext.translations.modalCheckInStepOneMessage}
          />
        }
        <PreCheckInStep 
          active={stepperForm.step === PreChekInStepEnum.PrincipalInfos}
          /*onClick={() => handleStepGuard(PreChekInStepEnum.PrincipalInfos)}*/
          icon='info'
          title={globalContext.translations.modalCheckInStepTwoTitle}
          description={globalContext.translations.modalCheckInStepTwoMessage}
        />
        <PreCheckInStep 
          active={stepperForm.step === PreChekInStepEnum.SecondaryInfos}
          /*onClick={() => handleStepGuard(PreChekInStepEnum.SecondaryInfos)}*/
          icon='info'
          title={globalContext.translations.modalCheckInStepThreeTitle}
          description={globalContext.translations.modalCheckInStepThreeMessage}
        />
      </Step.Group>
    </Segment>
  )
}

export default PreCheckInStepHeader